import { orderStatus, fieldProvinceVUL } from '../../utils/constant';
import { computeIsThisVulcanOrder } from './businessRulesAdapter';

/**
 * Factory for the engine's `payload` adapter (FR-019).
 *
 * Extracted from `vulcanSubmitPayload` (formSubmitLogic.js:265) — payload
 * SHAPING only. The original function also performed the HTTP request
 * (`axios.put`/`axios.post` directly, bypassing the app's centralized
 * `request.js` — a pre-existing constitution §4.1 violation) and, on specific
 * steps, an async file upload (`submitFile`). Neither belongs in a payload
 * adapter (`(values, context) => payload`, synchronous, no I/O per the engine's
 * contract):
 *   - The actual order create/update HTTP call is the consumer's `onSubmit`,
 *     routed through `request.js` (T052 — the §4.1 fix).
 *   - The file-upload side effect remains a separate step in `onSubmit`
 *     alongside the main request, unchanged from today's behavior.
 *
 * @param {{yes: string}} translations `vulcanWebform.yes` from the active locale
 * @returns {import('@mobilelive-inc/telus-forms-core').PayloadAdapter}
 */
export function createVulcanPayloadAdapter({ yes }) {
  return (values, context) => {
    const { orderData = {}, isFormLastStep } = context || {};
    const payload = { ...values };

    if (orderData.id) {
      if (isFormLastStep) {
        payload.completedAt = new Date();
        payload.status = orderStatus.submitted;
      }
    } else {
      payload.typeOfOrder = 'VUL';
      payload.status = orderStatus.incomplete;
      payload.step = 1;
    }

    if (fieldProvinceVUL in values) {
      payload.isThisVulcanOrder = computeIsThisVulcanOrder(values, yes);
    }

    return payload;
  };
}
